import {AdRPeriod} from '../../interfaces/ad-reports';

export const PERIODS_STATE_NAME = 'periods';

export interface PeriodsState {
  periods: Array<AdRPeriod>
}
